var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23916 4C5.23916 2.48122 6.47037 1.25 7.98916 1.25H15.9892C17.5079 1.25 18.7392 2.48122 18.7392 4V16C18.7392 17.5188 17.5079 18.75 15.9892 18.75H7.98916C6.47037 18.75 5.23916 17.5188 5.23916 16V4ZM7.98916 2.75C7.2988 2.75 6.73916 3.30964 6.73916 4V16C6.73916 16.6904 7.2988 17.25 7.98916 17.25H15.9892C16.6795 17.25 17.2392 16.6904 17.2392 16V4C17.2392 3.30964 16.6795 2.75 15.9892 2.75H7.98916Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98916 21.25C7.98916 20.8358 8.32494 20.5 8.73916 20.5H15.2392C15.6534 20.5 15.9892 20.8358 15.9892 21.25C15.9892 21.6642 15.6534 22 15.2392 22H8.73916C8.32494 22 7.98916 21.6642 7.98916 21.25Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58916 17.45C7.92053 17.6985 7.98768 18.1686 7.73916 18.5L4.43916 22.9C4.19063 23.2314 3.72053 23.2985 3.38916 23.05C3.05778 22.8015 2.99063 22.3314 3.23916 22L6.53916 17.6C6.78768 17.2686 7.25778 17.2015 7.58916 17.45Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3892 17.45C16.0578 17.6985 15.9906 18.1686 16.2392 18.5L19.5392 22.9C19.7877 23.2314 20.2578 23.2985 20.5892 23.05C20.9205 22.8015 20.9877 22.3314 20.7392 22L17.4392 17.6C17.1906 17.2686 16.7205 17.2015 16.3892 17.45Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98916 14C9.98916 14.5523 9.54144 15 8.98916 15C8.43687 15 7.98916 14.5523 7.98916 14C7.98916 13.4477 8.43687 13 8.98916 13C9.54144 13 9.98916 13.4477 9.98916 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9892 14C15.9892 14.5523 15.5414 15 14.9892 15C14.4369 15 13.9892 14.5523 13.9892 14C13.9892 13.4477 14.4369 13 14.9892 13C15.5414 13 15.9892 13.4477 15.9892 14Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98916 6C7.98916 5.44772 8.43687 5 8.98916 5H14.9892C15.5414 5 15.9892 5.44772 15.9892 6V10C15.9892 10.5523 15.5414 11 14.9892 11H8.98916C8.43687 11 7.98916 10.5523 7.98916 10V6Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/Transportation.aed187badf634fc1b0f584d4f19c4775.svg";
export { ForwardRef as ReactComponent };